import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import bissines from "../../assets/Business.png";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Container } from "@mui/system";
import { Divider } from "@mui/material";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import {
  useFindJobRecommendApiQuery,
  useFindUserApiQuery,
} from "../../services/apiSlice";
import Swal from "sweetalert2";
import Loading from "../Loading";
import { GetJobSearchResult } from "./find-job/GetJobSearchResult";
import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function MediaCard() {
  const {
    data,
    error: e,
    isError: is,
    isSuccess,
    isFetching,
  } = useFindUserApiQuery();
  return (
    <Container sx={[{ my: 8 }]}>
      <Fade cascade>
        <Paper
          sx={[
            { maxWidth: "lg", ml: 10, my: 8 },
            (theme) => ({
              [theme.breakpoints.down("sm")]: {
                py: 3,
                mx: 3,
                ml: 3,
              },
            }),
          ]}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 4,
            }}
          >
            <Typography
              variant="h1"
              component="p"
              className="text-lg  font-normal text-center py-5"
            >
              My Status
            </Typography>{" "}
            <Typography
              variant="span"
              component="span"
              className="text-lg text-orange-400 py-5  font-normal text-center  "
            >
              Free trial
            </Typography>
          </Box>
          <Divider />
          {/* <Typography
          variant="h1"
          component="h2"
          className="text-3xl  font-extrabold text-center py-12 md:py-20 "
        >
          Recommended for you
        </Typography>
        <Divider />
        <Typography
          variant="h1"
          component="h2"
          className="text-3xl  font-extrabold text-center py-12 md:py-20 "
        >
          Recommended for you
        </Typography> */}
        </Paper>
        {isSuccess && data?.getUserObject?.user_type === "individual" && (
          <>
            <Box
              sx={[
                { maxWidth: "lg", ml: 10, my: 8 },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    py: 3,
                    mx: 3,
                    ml: 3,
                  },
                }),
              ]}
            >
              <Divider />
              <Typography
                variant="h1"
                component="h2"
                className="text-3xl  font-extrabold text-center py-12 md:py-20 "
              >
                Recommended for you
              </Typography>
              <Grid
                container
                item
                spacing={{ xs: 2, md: 4, my: 3 }}
                // columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid
                  className="lg:w-[30%] md:pb-5 md:w-[40%]  sm:w-2/4"
                  sx={[
                    { px: 2 },
                    (theme) => ({
                      [theme.breakpoints.down("sm")]: {
                        width: "90%",
                        py: 3,
                        mx: 3,
                      },
                    }),
                  ]}
                >
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image={bissines}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        HVAC
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Lizards are a widespread group of squamate reptiles,
                        with over 6,000 species, ranging across all continents
                        except Antarctica
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small">Share</Button>
                      <Button size="small">Learn More</Button>
                    </CardActions>
                  </Card>{" "}
                  {/* <Item>3</Item> */}
                </Grid>
                <Grid
                  className="lg:w-[30%]  md:pb-5  md:w-[40%]  sm:w-2/4"
                  sx={[
                    { px: 2 },
                    (theme) => ({
                      [theme.breakpoints.down("sm")]: {
                        width: "90%",
                        py: 3,
                        mx: 3,
                      },
                    }),
                  ]}
                >
                  {" "}
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image={bissines}
                      xs={6}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Electrical
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Lizards are a widespread group of squamate reptiles,
                        with over 6,000 species, ranging across all continents
                        except Antarctica
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small">Share</Button>
                      <Button size="small">Learn More</Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid
                  className="lg:w-[30%]  md:pb-5  md:w-[40%]  sm:w-2/4"
                  sx={[
                    { px: 2 },
                    (theme) => ({
                      [theme.breakpoints.down("sm")]: {
                        width: "90%",
                        py: 3,
                        mx: 3,
                      },
                    }),
                  ]}
                >
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image={bissines}
                      xs={6}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Lizard
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Lizards are a widespread group of squamate reptiles,
                        with over 6,000 species, ranging across all continents
                        except Antarctica
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small">Share</Button>
                      <Button size="small">Learn More</Button>
                    </CardActions>
                  </Card>
                </Grid>{" "}
                <Grid
                  className="lg:w-[30%] md:pb-5 md:w-[40%]  sm:w-2/4"
                  sx={[
                    { px: 2 },
                    (theme) => ({
                      [theme.breakpoints.down("sm")]: {
                        width: "90%",
                        py: 3,
                        mx: 3,
                      },
                    }),
                  ]}
                >
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image={bissines}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Contractor
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Lizards are a widespread group of squamate reptiles,
                        with over 6,000 species, ranging across all continents
                        except Antarctica
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small">Share</Button>
                      <Button size="small">Learn More</Button>
                    </CardActions>
                  </Card>{" "}
                  {/* <Item>3</Item> */}
                </Grid>
                <Grid
                  className="lg:w-[30%]  md:pb-5  md:w-[40%]  sm:w-2/4"
                  sx={[
                    { px: 2 },
                    (theme) => ({
                      [theme.breakpoints.down("sm")]: {
                        width: "90%",
                        py: 3,
                        mx: 3,
                      },
                    }),
                  ]}
                >
                  {" "}
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image={bissines}
                      xs={6}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Tiler
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Lizards are a widespread group of squamate reptiles,
                        with over 6,000 species, ranging across all continents
                        except Antarctica
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small">Share</Button>
                      <Button size="small">Learn More</Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid
                  className="lg:w-[30%]  md:pb-5  md:w-[40%]  sm:w-2/4"
                  sx={[
                    { px: 2 },
                    (theme) => ({
                      [theme.breakpoints.down("sm")]: {
                        width: "90%",
                        py: 3,
                        mx: 3,
                      },
                    }),
                  ]}
                >
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image={bissines}
                      xs={6}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Plumber
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Lizards are a widespread group of squamate reptiles,
                        with over 6,000 species, ranging across all continents
                        except Antarctica
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small">Share</Button>
                      <Button size="small">Learn More</Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </Box>

            <Paper
              sx={[
                {
                  maxWidth: "lg",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  ml: 10,
                  my: 15,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    py: 3,
                    mx: 3,
                    ml: 3,
                  },
                }),
              ]}
            >
              <Typography
                variant="p"
                component="p"
                className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
              >
                Upgrade today to enjoy the full benefits of TOP Neigbourhood
                Pro's Premium Membership
              </Typography>
              <Link to={"/dashboard/sub-premium-plan"}>
                <Button className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full">
                  Find out more
                </Button>
              </Link>
            </Paper>
          </>
        )}
      </Fade>
    </Container>
  );
}

export const DashBoardJob = () => {
  // useFindJobByCategoryApiQuery, useFindJobByZipCodeApiQuery;
  const {
    data,
    error: e,
    isError: is,
    isSuccess,
    isFetching,
  } = useFindUserApiQuery();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const currentParams = Object.fromEntries([...searchParams]);
    console.log({ currentParams });
    if (currentParams.success === "true") {
      Swal.fire(
        "Awosome!",
        ` Your subscription have been successfull`,
        "success"
      ).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          navigate(`/dashboard`);
        }
      });
    }
  }, [searchParams]);

  return (
    <>
      {" "}
      <Container>
        <Fade cascade>
          <Box
            // component="form"
            // onSubmit={handleSubmit(onSubmit)}
            className="min-h-screen"
            sx={{ mt: 5, ml: 4 }}
            style={{
              display: "flex",

              // padding: "20px",
              // margin: "4px 10px",
              flexDirection: "column",
            }}
          >
            <Paper
              sx={[
                { maxWidth: "lg", ml: 10, my: 9 },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    py: 3,
                    mx: 3,
                    ml: 3,
                  },
                }),
              ]}
            >
              <Box
                sx={[
                  {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 4,
                  },
                  (theme) => ({
                    [theme.breakpoints.down("sm")]: {
                      px: 1,
                    },
                  }),
                ]}
              >
                <Typography
                  variant="h1"
                  component="p"
                  className="md:text-lg text-base font-normal text-center py-5"
                >
                  My Status
                </Typography>{" "}
                <Typography
                  variant="span"
                  component="span"
                  className="md:text-lg text-base px-2 text-orange-400 py-5  font-normal text-center  "
                >
                  {data?.getUserObject?.subscriptionPlan?.type}
                </Typography>
              </Box>

              <Divider />
              {/* <Typography
          variant="h1"
          component="h2"
          className="text-3xl  font-extrabold text-center py-12 md:py-20 "
        >
          Recommended for you
        </Typography>
        <Divider />
        <Typography
          variant="h1"
          component="h2"
          className="text-3xl  font-extrabold text-center py-12 md:py-20 "
        >
          Recommended for you
        </Typography> */}
            </Paper>

            {isSuccess && data?.getUserObject?.user_type === "individual" && (
              <>
                <Typography
                  variant="h1"
                  component="h2"
                  className="md:text-3xl text-lg font-extrabold text-center py-12 md:py-20 "
                >
                  Recommended for you
                </Typography>
                <SearchResult />

                {isSuccess &&
                  data?.getUserObject?.subscriptionPlan?.type !== "Premium" && (
                    <Paper
                      sx={[
                        {
                          maxWidth: "lg",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          ml: 10,
                          my: 15,
                        },
                        (theme) => ({
                          [theme.breakpoints.down("sm")]: {
                            py: 3,
                            mx: 3,
                            ml: 3,
                          },
                        }),
                      ]}
                    >
                      <Typography
                        variant="p"
                        component="p"
                        className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
                      >
                        Upgrade today to enjoy the full benefits of TOP
                        Neigbourhood Pro's Premium Membership
                      </Typography>
                      <Link to={"/dashboard/sub-premium-plan"}>
                        <Button className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full">
                          Find out more
                        </Button>
                      </Link>
                    </Paper>
                  )}
              </>
            )}
          </Box>
        </Fade>
      </Container>
    </>
  );
};

const SearchResult = (props) => {
  const { data, error, isError, isSuccess, isFetching } =
    useFindJobRecommendApiQuery();

  console.log({ data });

  let AllResult;
  if (isFetching) {
    AllResult = <Loading />;
  } else if (isSuccess) {
    AllResult = data?.getAvailableJob;
  } else if (isError) {
    AllResult = Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error?.data?.message,
    });
  }

  return (
    <div className="flex  md:ml-20 justify-center  flex-col w-full  ">
      {data?.getAvailableJob.length > 0 ? (
        <GetJobSearchResult AllResult={AllResult} />
      ) : (
        <p className="py-4 text-center font-bold text-xs sm:text-base md:text-xl mx-3">
          No result found available
        </p>
      )}
    </div>
  );
};

// export default function RowAndColumnSpacing() {
//   return (
//     <Box sx={{ width: "100%" }}>

//     </Box>
//   );
// }
